import React from 'react'
import s from '../CreateQuiz.module.scss'
import { getMediaFullUrl } from '../../../helper/getMediaFullUrl'

export const ExistingQuizzes = ({ quiz, enterEditingMode, isQuizArchived }) => {
    function goToQuiz() {
        enterEditingMode(quiz)
    }
    return (
        <div className={s.existingQuiz} onClick={goToQuiz}>
            <img src={getMediaFullUrl(quiz.image)} alt=""
                style={{
                    width: 'auto',
                    height: '292px',
                    borderRadius: '16px',
                }}
            />
            <div className={s.title}>
                {quiz.title}
            </div>
            <div className={s.archivedOrActive}>
                {isQuizArchived(quiz) ? 'Archived' : 'Active'}
            </div>
        </div>
    )
}
